module.exports = __webpack_public_path__ + "img/adding-prototype-methods.5930689d.png";